import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import { useAdminPage } from './useAdminPage';
import GumballIcon from '../components/GumballIcon';
import './css/admin-layout.css';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/admin/announcements', label: 'Announcements', icon: 'megaphone' },
  { to: '/admin/roadmap', label: 'Roadmap', icon: 'roadmap' },
  { to: '/admin/homepage', label: 'Homepage', icon: 'home' },
  { to: '/admin/socials', label: 'Social Links', icon: 'link' },
  { to: '/admin/media', label: 'Media', icon: 'media' },
];

export default function AdminLayout() {
  useAdminPage();
  const { user, logout } = useAdmin();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-app">
      <button
        type="button"
        className="admin-menu-toggle"
        aria-label="Toggle menu"
        onClick={() => setSidebarOpen((o) => !o)}
      >
        <GumballIcon name="menu" size={22} />
      </button>

      {sidebarOpen && (
        <button
          type="button"
          className="admin-sidebar-scrim"
          aria-label="Close menu"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="admin-brand">
          <span className="admin-brand-icon">
            <GumballIcon name="bubble" size={32} />
          </span>
          <div>
            <p className="admin-brand-title">Gumball Buddies</p>
            <p className="admin-brand-sub">Admin Dashboard</p>
          </div>
        </div>

        <nav className="admin-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="admin-nav-icon">
                <GumballIcon name={item.icon} size={18} />
              </span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <a href="/" target="_blank" rel="noopener noreferrer" className="admin-view-site">
            View Site <GumballIcon name="external" size={14} className="admin-inline-icon" />
          </a>
          <button type="button" className="admin-logout-btn" onClick={handleLogout}>
            Sign out ({user?.username})
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
